<template>
    <div>
        <div class="modal fade" id="availableprojectdetails" tabindex="-1" aria-labelledby="availableprojectdetails" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title title-modal" id="addCoach">Available Project Details</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="detail-page-container">
                        <div class="content-card">
                        
                        <!-- Top Image Header Banner Area -->
                        <div class="banner-wrapper">
                            <img 
                            src="../../assets/images/prop1.svg" 
                            alt="Solar Installation Worker" 
                            class="banner-image"
                            />
                            <!-- Category Badge Tag overlay -->
                            <div class="tag-electricity">
                            <svg class="icon-lightning" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M13 10V3L4 14h7v7l9-11h-7z"/>
                            </svg>
                            <span class="tag-label">Electricity</span>
                            </div>
                            <!-- Image Slide Position Navigation Indicators -->
                            <div class="carousel-indicators">
                            <span class="dot"></span>
                            <span class="dot active"></span>
                            <span class="dot"></span>
                            </div>
                        </div>

                        <!-- Main Project Overview Text Section -->
                        <div class="project-header">
                            <h1 class="main-title">Solar Homes Installation</h1>
                            
                            <!-- Metadata Rows with Icons -->
                            <div class="meta-list">
                            <div class="meta-item">
                                <svg class="meta-icon" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                                <path stroke-linecap="round" stroke-linejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
                                </svg>
                                <span class="meta-text">Lagos, Nigeria</span>
                            </div>

                            <div class="meta-item">
                                <svg class="meta-icon" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                                </svg>
                                <span class="meta-text">Organized by: <strong class="dark-text">Shelta Property Energy Ltd</strong></span>
                            </div>

                            <div class="meta-item">
                                <svg class="meta-icon" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
                                </svg>
                                <span class="meta-text">20 Participant</span>
                            </div>
                            </div>
                        </div>

                        <!-- Segmented Control Navigation Tabs Toggle Section -->
                        <div class="navigation-tabs-wrapper">
                            <button 
                            @click="currentSection = 'overview'" 
                            :class="['section-tab', { active: currentSection === 'overview' }]"
                            >
                            Overview
                            </button>
                            <button 
                            @click="currentSection = 'media'" 
                            :class="['section-tab', { active: currentSection === 'media' }]"
                            >
                            Media & Docs
                            </button>
                        </div>

                        <!-- Tab Content Area Container -->
                        <div class="tab-view-content" v-if="currentSection === 'overview'">
                            
                                <!-- Project Funding Breakdown Block Summary -->
                                <div class="funding-plan-box">
                                    <h3 class="plan-header-title">Project Funding Plan</h3>
                                    <div class="plan-grid-metrics">
                                        <div class="metric-column">
                                        <span class="metric-label">Project Amount</span>
                                        <span class="metric-value font-bold">&#8358;1,200,000</span>
                                        </div>
                                        <div class="metric-column border-side">
                                        <span class="metric-label">Payment Plan</span>
                                        <span class="metric-value font-bold">Monthly</span>
                                        </div>
                                        <div class="metric-column">
                                        <span class="metric-label">Equity</span>
                                        <span class="metric-value font-bold">&#8358;200,000</span>
                                        </div>
                                    </div>
                                </div>

                                <!-- System Informational Alert Banner Box Notice element -->
                                <div class="info-alert-callout">
                                    <div class="icon-circle-info">
                                        <svg class="alert-svg-icon" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                                        </svg>
                                    </div>
                                    <p class="alert-text-message">
                                        Pay a fixed equity contribution between Oct 26 - Nov 6, 2025 to confirm participation and start funding via your SAFE wallet.
                                    </p>
                                </div>

                                <!-- Description Paragraph Context Copy Area -->
                                <div class="about-project-section">
                                    <h3 class="about-header-title">About Project</h3>
                                    <p class="description-body-paragraph">
                                        This project will install affordable solar power systems in 10 homes across Lagos Mainland, reducing household energy costs by up to 60%. This project will install affordable solar power systems in 10 homes across Lagos Mainland, reducing household energy costs by up to 60%.
                                    </p>
                                </div>

                                <!-- ─── CARD 3: FUNDING PLAN BREAKDOWN MATRIX ─── -->
                                <div class="metrics-card card-shadow no-padding-bottom">
                                    <h3 class="section-component-title padding-bottom-md">Funding Plan</h3>

                                    <div class="matrix-table-row border-bottom-divider">
                                        <span class="funding_plan">Project Amount</span>
                                        <span class="fund_value">₦24,000,000</span>
                                    </div>

                                    <div class="matrix-table-row border-bottom-divider">
                                        <span class="funding_plan">Payment Plan</span>
                                        <span class="fund_value">₦2,400,000 / Monthly</span>
                                    </div>

                                    <div class="matrix-table-row border-bottom-divider">
                                        <span class="funding_plan">Project Duration</span>
                                        <span class="fund_value">12 Months</span>
                                    </div>

                                    <div class="matrix-table-row padding-vertical-lg">
                                        <span class="funding_plan">Start Date - End Date</span>
                                        <span class="fund_value date-range-text">Nov 12, 2025 - Dec 12, 2026</span>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>

                    <div class="button-class container">
                        <button class="btn primaryBtn w-100" @click="closeModalFund()">Join Project Now</button>
                    </div>


                    
                </div>
            </div>
        </div>


        
    </div>
</template>


<script>
import { Service } from "../../store/service";
const Api = new Service();
import PageLoader from "../../components/PageLoader.vue";
import moment from "moment";
import $ from "jquery";
export default {
    components: {
        PageLoader,
    },
    props: {
        // Receive the data snapshot passed from parent
        projectData: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            currentSection: 'overview'
        };
    },
    created() {

    },
    mounted() {
        console.log("Prject details in modal:", this.projectData)
    },
    methods: {
        routeTo(route) {
            this.$router
            .push({
            path: `${route}`
            })
            .catch(() => {
            // console.log("none")
            });
        },
        closeModalFund() {
            console.log("close now open")
            $("#projectdetails")
            .removeClass("fade")
            .modal("hide");

            $("#fundproject")
            .addClass("fade")
            .modal("show");
            // this.projectModalData = { ...details };
        }
    }
};
</script>



<style lang="scss" scoped>
// System Layout Tokens & Colors variables definitions
$color-brand-blue: #0040E5;
$color-alert-blue-bg: #EFF4FF;
$color-alert-blue-text: #2B66E6;
$color-orange-tag: #FFA500;
$color-text-main-heading: #0A0A0A;
$color-text-body-dark: #333333;
$color-text-secondary-label: #6B7280;
$color-border-divider: #E5E7EB;
$color-page-bg-gray: #F8F9FA;

.button-class {
    margin-bottom: 50px;
    .primaryBtn {
        background: #0033EA;
        color: #ffffff;
        font-family: Lato;
        font-weight: 500;
        font-size: 16px;
        height: 45px;
        outline: 0;
        box-shadow: none;
    }
}

.detail-page-container {
  min-height: 100vh;
  background-color: $color-page-bg-gray;
  padding: 1.5rem 1rem;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
}

.content-card {
  width: 100%;
  max-width: 440px;
  background-color: #FFFFFF;
  border-radius: 1.5rem;
  overflow: hidden;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.02);
  padding-bottom: 2rem;
}

// Media Header Area Banner Layout style
.banner-wrapper {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 8.5;
  background-color: #EAEAEA;

  .banner-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.tag-electricity {
  position: absolute;
  top: 0.875rem;
  left: 0.875rem;
  background-color: #FFFFFF;
  border-radius: 9999px;
  padding: 0.35rem 0.75rem;
  display: flex;
  align-items: center;
  gap: 0.35rem;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);

  .icon-lightning {
    width: 0.875rem;
    height: 0.875rem;
    color: $color-orange-tag;
  }

  .tag-label {
    color: #4A4A4A;
    font-size: 0.8125rem;
    font-weight: 500;
  }
}

.carousel-indicators {
  position: absolute;
  bottom: 0.875rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 0.35rem;

  .dot {
    width: 0.375rem;
    height: 0.375rem;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.4);

    &.active {
      background-color: #FFFFFF;
      width: 0.45rem;
      height: 0.45rem;
    }
  }
}

// Project Details Header Information Section Block
.project-header {
  padding: 1.25rem 1.25rem 0 1.25rem;

  .main-title {
    font-size: 1.35rem;
    font-weight: 700;
    color: $color-text-main-heading;
    margin: 0 0 1.25rem 0;
    letter-spacing: -0.01em;
  }
}

.meta-list {
  display: flex;
  flex-direction: column;
  gap: 0.875rem;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;

  .meta-icon {
    width: 1.15rem;
    height: 1.15rem;
    color: $color-text-secondary-label;
    flex-shrink: 0;
  }

  .meta-text {
    font-size: 0.9375rem;
    color: #555555;
    font-weight: 400;

    .dark-text {
      color: $color-text-body-dark;
      font-weight: 500;
    }
  }
}

// Fixed Segment Control Nav Menu View Tabs Layout Elements styling
.navigation-tabs-wrapper {
  margin-top: 2rem;
  display: flex;
  border-bottom: 1.5px solid #F0F2F5;
  padding: 0 1rem;
}

.section-tab {
  flex: 1;
  background: none;
  border: none;
  padding: 0.875rem 0;
  font-size: 0.9375rem;
  font-weight: 500;
  color: $color-text-secondary-label;
  cursor: pointer;
  text-align: center;
  position: relative;
  transition: color 0.15s ease;

  &.active {
    color: $color-brand-blue;
    font-weight: 600;

    &::after {
      content: '';
      position: absolute;
      bottom: -1.5px;
      left: 0;
      width: 100%;
      height: 2px;
      background-color: $color-brand-blue;
    }
  }
}

// Tab Panels View Contents styling rules layout 
.tab-view-content {
  padding: 1.5rem 1.25rem;
}

.funding-plan-box {
  background-color: #FFFFFF;
  border: 1px solid #F3F4F6;
  border-radius: 1rem;
  padding: 1.25rem;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.015);

  .plan-header-title {
    font-size: 0.95rem;
    font-weight: 700;
    color: $color-text-main-heading;
    margin: 0 0 1.25rem 0;
  }
}

.plan-grid-metrics {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.metric-column {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  align-items: center;
  text-align: center;
  min-width: 100px;

  &.border-side {
    border-left: 1px solid #E5E7EB;
    border-right: 1px solid #E5E7EB;
  }

  .metric-label {
    font-size: 0.8125rem;
    color: $color-text-secondary-label;
    font-weight: 400;
  }

  .metric-value {
    font-size: 0.95rem;
    color: $color-text-main-heading;
    font-weight: 700;
  }
}

// Information Accent Callout Alert container element styling properties rules
.info-alert-callout {
  margin-top: 1.25rem;
  background-color: $color-alert-blue-bg;
  border-radius: 0.75rem;
  padding: 0.875rem 1rem;
  display: flex;
  gap: 0.625rem;
  align-items: flex-start;

  .icon-circle-info {
    flex-shrink: 0;
    margin-top: 0.125rem;

    .alert-svg-icon {
      width: 1.15rem;
      height: 1.15rem;
      color: $color-alert-blue-text;
    }
  }

  .alert-text-message {
    margin: 0;
    font-size: 0.8125rem;
    line-height: 1.4;
    color: $color-alert-blue-text;
    font-weight: 400;
  }
}

// Content Summary section typography block styles details parameters config
.about-project-section {
  margin-top: 1.75rem;

  .about-header-title {
    font-size: 0.95rem;
    font-weight: 700;
    color: $color-text-main-heading;
    margin: 0 0 0.875rem 0;
  }

  .description-body-paragraph {
    margin: 0;
    font-size: 0.875rem;
    line-height: 1.6;
    color: #4B5563;
    font-weight: 400;
    text-align: justify;
  }
}

/* Base configuration parameters for all UI block frames */
.metrics-card {
  background-color: #ffffff;
  border-radius: 20px;
  padding: 24px;
  margin-bottom: 20px;
  box-sizing: border-box;
}

.no-padding-bottom { padding-bottom: 0px; }
.padding-bottom-md { margin-bottom: 16px; }


.section-component-title {
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  font-family: Lato;
}

.matrix-table-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
}

.border-bottom-divider {
  border-bottom: 1px solid #f1f5f9;
}

.padding-vertical-lg { padding: 24px 0; }

.funding_plan {
  color: #64748b;
  font-size: 15px;
  font-weight: 500;
  font-family: Lato;
  text-align: left;
}

.fund_value {
  color: #0f172a;
  font-weight: 700;
  font-size: 16px;
  font-family: Lato;
  text-align: right;
}

.date-range-text {
  font-weight: 600;
  color: #334155;
  font-family: Lato;
}
</style>